export const NPA_STATUS_IDS = {
  IN_DISCUSS: 3,
  CONSIDERED: 4,
  DISCUSS_CLOSE: 5,
}


const STATUS_BADGE_CLASS_MAP = {
  [NPA_STATUS_IDS.IN_DISCUSS]: 'npa-status-badge npa-status-badge--in-discuss',
  [NPA_STATUS_IDS.CONSIDERED]: 'npa-status-badge npa-status-badge--considered',
  [NPA_STATUS_IDS.DISCUSS_CLOSE]: 'npa-status-badge npa-status-badge--closed',
}

export function getNpaStatusBadgeClass(statusId) {
  return STATUS_BADGE_CLASS_MAP[Number(statusId)] || ''
}

export function shouldShowJkStatusBadge(statusId, jkStatusText) {
  return Number(statusId) === NPA_STATUS_IDS.DISCUSS_CLOSE && Boolean(jkStatusText)
}
